import { Box, Heading } from "@chakra-ui/react";
import { VTUFeature } from "../dashboard/components/VTUFeature";

export const VtuPage = () => {
  return (
    <Box>
      <VTUFeature />
    </Box>
  );
};
